export default __webpack_public_path__ + "static/media/umbrella-black.bc8fcc8b.svg";